export default __webpack_public_path__ + "locales/ru/FillPDFDialog.json?hash=60960290335fd79601f3aa9a571a272a";